export const ROUTES = {
  // Invitation route
  INVITATION: "/invite/:inviteToken",

  // External links
  TERMS: "https://appdomus.io/terminos-y-condiciones",
  PRIVACY: "https://appdomus.io/privacidad",
} as const;
